import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";

const prepareAlterEstateToClient = (res: IPropertyDetailsResponse) => {
  return {
    [CPropertyFormKeys.want_publish_on_alterestate]: Boolean(
      res?.is_alterestate_sync
    ),
    [CPropertyFormKeys.want_publish_on_internal_alterestate]: Boolean(
      res?.is_alterestate_published
    ),
    [CPropertyFormKeys.garante_commission_alterestate]: res?.alterestate_commission
      ? String(res.alterestate_commission)
      : ""
  };
};

export default prepareAlterEstateToClient;
